// extracted by mini-css-extract-plugin
var _1 = "RadioColor_black__HP6ex";
var _2 = "RadioColor_explanation__c07q8";
var _3 = "768px";
var _4 = "RadioColor_radioColorContainer__6Cjmn";
var _5 = "RadioColor_radioColorInput__jUZk-";
var _6 = "'../../../shared.module.css'";
var _7 = "RadioColor_white__fBJxv";
export { _1 as "black", _2 as "explanation", _3 as "md", _4 as "radioColorContainer", _5 as "radioColorInput", _6 as "shared", _7 as "white" }
